// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1pnYI","title":"Images45_title__13M0O","images":"Images45_images__1XZfm"};